<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="title">TARAS GRESCOE</p>
<p class="title1">SHANGHAI GRAND</p>
<p class="title2"><em>Forbidden Love and International Intrigue in a Doomed World</em></p>
<p class="title"><img alt="" src="OEBPS/images/tp.jpg"/></p>
<p class="logo">St. Martin’s Press  <img alt="" class="inline" src="OEBPS/images/logo.png"/>  New York</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?31c65803